export default __webpack_public_path__ + "static/media/icon-calendar.68b09599.svg";